
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host(.mobile-open-scroll){
  box-sizing:border-box;
  overflow-y:scroll;
  position:fixed;
  width:100%;
  height:100%;
  z-index:10;
  top:0;
}

.sic-main-header{
  position:relative;
  width:100%;
  background-color:var(--color-neutral-white);
  transition:0.3s;
  z-index:200;
  top:var(--top-position);
}

.sic-main-header.fixed{
    position:fixed;
    transition:0.3s;
  }

.sic-main-header-top-rail{
  display:flex;
  align-items:center;
  height:123px;
  justify-content:space-between;
  column-gap:0.5rem;
}

@media (min-width: 1024px){

.sic-main-header-top-rail{
    column-gap:1rem
}
  }

.sic-main-header--logo{
  display:block;
  width:125px;
  min-width:55px;
}

.sic-main-header--contact-log-wrapper{
  display:flex;
  flex-wrap:wrap;
  row-gap:0.75rem;
  align-items:center;
  justify-content:center;
}

@media (min-width: 1024px){

.sic-main-header--contact-log-wrapper{
    flex-wrap:nowrap;
    column-gap:1.5rem
}
  }

.sic-main-header--search{
  display:block;
  max-width:865px;
  width:100%;
  margin:0 auto;
}

.sic-main-header--search-button{
  background-color:var(--color-neutral-white);
  color:var(--color-primary-default);
  border:none;
  border-radius:var(--border-radius-outline-default);
  cursor:pointer;
  min-height:45px;
  min-width:45px;
}

.sic-main-header--search-button .btn{
    padding:0;
    min-height:0;
    border:none;
  }

.sic-main-header--search-button:focus,
  .sic-main-header--search-button .btn:focus{
    outline-offset:0.25rem;
    outline:solid 2px var(--color-primary-default);
    border:none;
  }

.sic-main-header--search-button sic-icon{
    margin-left:auto;
    margin-right:auto;
  }

.sic-main-header--search-close-button{
  background-color:var(--color-neutral-white);
  color:var(--color-primary-default);
  border:none;
  border-radius:var(--border-radius-outline-default);
  align-self:flex-end;
  cursor:pointer;
  min-height:45px;
  min-width:45px;
  padding:0;
}

.sic-main-header--search-close-button:focus{
    outline-offset:0.25rem;
    outline:solid 2px var(--color-primary-default);
    border:none;
  }

.sic-main-header--search-close-button sic-icon{
    margin-left:auto;
    margin-right:auto;
  }

.sic-main-header--search-wrapper{
  display:none;
  flex-direction:column;
  z-index:3;
  background-color:var(--color-neutral-white);
}

.sic-main-header--search-wrapper.open{
    display:flex;
    position:absolute;
    top:123px;
    right:0;
    left:0;
  }

.sic-main-header--search-close-wrapper{
  display:flex;
  align-self:flex-end;
  padding-right:0;
  padding-right:var(--x-padding, 0);
}

:host(.mobile-open-scroll) .sic-main-header{
    width:85%;
  }

.sic-main-header--utility-wrapper-mobile{
  position:relative;
  top:0;
  top:var(--mobile-utility-offset, 0);
  background-color:var(--color-neutral-white);
}

.sic-main-header--top-rail-mobile{
  display:flex;
  height:85px;
  align-items:center;
  padding:0 1rem;
}

.sic-main-header--menu-toggle-button-mobile{
  background-color:var(--color-neutral-white);
  border:none;
}

.sic-main-header--footer-mobile{
  display:block;
  background-color:var(--color-primary-lightest);
  color:var(--color-neutral-default);
}

.sic-main-header--search-mobile{
  display:block;
  padding:0 1rem;
}

.sic-main-header--logo-mobile{
  display:block;
  max-width:80px;
  width:100%;
  margin-right:calc(50% - 50px);
  margin-left:auto;
}

.sic-main-header--login-mobile{
  display:block;
  min-width:80px;
}

.sic-main-header--login-mobile .btn{
    max-width:85px;
  }

.sic-main-header--nav-search-mobile{
  position:absolute;
  visibility:hidden;
  top:100%;
  background-color:var(--color-neutral-white);
  transition:0.3s;
  translate:-3000px;
  height:100vh;
}

.sic-main-header--nav-search-mobile.open{
    visibility:visible;
    display:block;
    width:100%;
    translate:0;
    transition:0.3s;
  }

@media (prefers-reduced-motion: reduce){
  .sic-main-header--nav-search-mobile,
  .sic-main-header--content-positioning,
  .sic-main-header--nav-search-mobile.open,
  .sic-main-header,
  .sic-main-header.fixed,
  .sic-main-header--nav-search-mobile{
    transition:none;
  }
}

.sic-main-header--content-positioning{
  transition:all 0.3s;
  height:0px;
}

.sic-main-header--content-positioning.fixed{
    height:var(--content-positioning-height);
    height:var(
      --content-positioning-height--override,
      var(--content-positioning-height)
    );
  }

.divider hr{
    border:var(--color-neutral-lighter) solid 0.5px;
  }
`;